import GiftGuideWaffle from './GiftGuideWaffle';

export default GiftGuideWaffle;
